var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "rb-newsletter-modal-content" }, [
      _c("div", { staticClass: "grid grid--gap-0" }, [
        !_vm.isMobile
          ? _c("div", { staticClass: "col-12 col-md-5" }, [
              _c(
                "div",
                {
                  staticClass: "rb-newsletter-modal-content__image",
                  attrs: { "aria-hidden": "true", role: "presentation" },
                },
                [_vm._t("content-left")],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              { ref: "modalRightContent", class: _vm.modalRightContentClasses },
              [
                !_vm.success
                  ? _c(
                      "div",
                      { staticClass: "signup-main" },
                      [_vm._t("content-right")],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.success
                  ? _c("div", [
                      _c(
                        "div",
                        [
                          _c("rb-textfield", {
                            staticClass:
                              "signUpEmail rb-editorial__txt-color--white",
                            attrs: {
                              id: "signUpEmail",
                              required: "required",
                              type: "text",
                              name: "signUpEmail",
                              "is-email": true,
                              label: _vm.translation(
                                "newsletter_overlay.overlay_signup_email_label"
                              ),
                              error: _vm.translation(
                                "newsletter_overlay.overlay_mail_error"
                              ),
                              validation: _vm.$v.signUpEmail,
                            },
                          }),
                          _vm._v(" "),
                          _vm.errorMessage
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "welcome_promo_error permanently-hide",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errorMessage) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "rb-newsletter-modal-content__privacy-policy",
                            },
                            [_vm._t("disclaimer")],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "submitButtonContainer" }, [
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rb-btn rb-btn--red",
                                attrs: {
                                  id: "X_X_SignUpOverlay_SignupForm",
                                  type: "",
                                  disabled: _vm.$v.signUpEmail.$error,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitNewsletterModalForm()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.translation(
                                        "newsletter_overlay.signup"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.success && !_vm.loading
                  ? _c("div", [
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "newsletter-success-container" },
                        [
                          _vm._t("success"),
                          _vm._v(" "),
                          _vm.canShowAdditionalField
                            ? _c("rb-newsletter-modal-content-success-form", {
                                attrs: { "sign-up-email": _vm.signUpEmail },
                                on: {
                                  closeNewsletterModal: function ($event) {
                                    return _vm.emitCloseNewsletterModal()
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _c(
              "div",
              {
                class: [
                  _vm.modalRightContentClasses,
                  "rb-newsletter-modal-content__loader",
                ],
                style: _vm.loaderDimensionCSSVariables,
              },
              [_c("rb-loader-glasses")],
              1
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }